import api from '@/api';
import _mapChildren from '../../utils/mapChildren';
import User from '@/models/core/User';

const state = {
  isLoading: false,
  isUpdating: false,
  active: [],
  pending: [],
  currentUser: null
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  isUpdating(state) {
    return state.isUpdating;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  }
};

// actions
const actions = {
  get({ dispatch }) {
    if (localStorage.getItem('authenticated')) {
      return new Promise(resolve => {
        api.get('/users/me').then(response => {
          dispatch(
            'normalize',
            { model: User, data: response.data.data },
            { root: true }
          );

          dispatch('entities/context/setUser', response.data.data.uuid, {
            root: true
          }).then(() => resolve());
        });
      });
    }
  },

  update({ commit }, value) {
    return new Promise(resolve => {
      commit('setUpdating', true);

      api.update(User, value).then(() => {
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  _getActiveUsers({ commit, rootState, state, getters }, params) {
    if (typeof params.query === 'undefined') {
      params.query = {};
    }
    return new Promise((resolve, reject) => {
      //Check if request needs to be done
      if (typeof params.forceUpdate === 'undefined') {
        params.forceUpdate = true;
      }
      if (state.active.length === 0 || params.forceUpdate) {
        //Als include the associate user group and role
        params.query.include = 'user';
        api
          .get(rootState.team + '/memberships', { params: params.query })
          .then(response => {
            let users = response.data.data;
            //If it is data for a table. Uncheck the top checkbox
            if (document.getElementById('checkAll')) {
              document.getElementById('checkAll').checked = false;
            }
            users.map(user => {
              user.name = user.user.first_name + ' ' + user.user.last_name;
              user.first_name = user.user.first_name;
              user.last_name = user.user.last_name;
            });
            commit('_setUsers', users);

            if (params.onlyModel) {
              resolve(users);
            } else {
              resolve({
                data: { data: users, _pagination: response.data._pagination }
              });
            }
          })
          .catch(error => {
            reject(error);
            console.error(error);
          });
      }
    });
  },
  _deleteUsers({ commit, dispatch }, users) {
    return new Promise((resolve, reject) => {
      //Map data for the api call
      let userUuids = null;
      if (Array.isArray(users)) {
        userUuids = users
          .map(user => {
            return user.uuid;
          })
          .join(',');
      } else {
        userUuids = users.uuid;
      }
      api
        .delete('/memerships/' + userUuids)
        .then(response => {
          //notify user and resolve the promise
          dispatch(
            'toasts/_addToast',
            { text: 'Users deleted' },
            { root: true }
          );
          resolve(response);
        })
        .catch(error => {
          console.error(error.response);
          reject(error.response.data.error.exception[0].message);
        });
    });
  },
  _updateUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      api
        .put('/memberships/' + user.uuid, user)
        .then(response => {
          console.log(response);
          resolve();
        })
        .catch(error => {
          console.error(error);
          reject(error.response.data.error.exception[0].message);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
